import React from 'react';
import { BundleCard } from './BundleCard';
export function MiniBundles() {
  const productImage = 'https://cdn.magicpatterns.com/uploads/q5pbc7UPXB7yZsJKNiRqwd/LymphoriaX_(6).png';
  const bundles = [{
    qty: 1,
    price: '34,95 €',
    original: '49,95 €',
    savings: 30
  }, {
    qty: 2,
    price: '54,95 €',
    original: '79,95 €',
    savings: 31
  }, {
    qty: 3,
    price: '64,95 €',
    original: '99,95 €',
    savings: 35,
    best: true
  }, {
    qty: 6,
    price: '99,95 €',
    original: '159,95 €',
    savings: 38
  }];
  return <div className="bg-white border-b border-gray-100 py-8 hidden md:block" data-id="element-205">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-206">
        <div className="grid grid-cols-4 gap-4" data-id="element-207">
          {bundles.map((b, i) => <div key={i} className={`
              p-4 rounded-xl border transition-all cursor-pointer hover:shadow-md
              ${b.best ? 'border-[#D4AF37] bg-[#D4AF37]/5' : 'border-gray-200'}
            `} data-id="element-208">
              {/* Product Image */}
              <div className="h-20 mb-3 flex items-center justify-center relative" data-id="element-209">
                {b.qty === 1 ? <img src={productImage} alt="StingFit" className="h-full w-auto object-contain" data-id="element-210" /> : b.qty === 2 ? <div className="relative h-full w-full flex items-center justify-center" data-id="element-211">
                    <img src={productImage} alt="StingFit" className="h-full w-auto object-contain absolute left-1 -rotate-6 opacity-70" data-id="element-212" />
                    <img src={productImage} alt="StingFit" className="h-full w-auto object-contain absolute right-1 rotate-6" data-id="element-213" />
                  </div> : b.qty === 3 ? <div className="relative h-full w-full flex items-center justify-center" data-id="element-214">
                    <img src={productImage} alt="StingFit" className="h-full w-auto object-contain absolute left-0 -rotate-12 opacity-50" data-id="element-215" />
                    <img src={productImage} alt="StingFit" className="h-full w-auto object-contain relative z-10" data-id="element-216" />
                    <img src={productImage} alt="StingFit" className="h-full w-auto object-contain absolute right-0 rotate-12 opacity-50" data-id="element-217" />
                  </div> : <div className="relative h-full w-full flex items-center justify-center" data-id="element-218">
                    <div className="grid grid-cols-3 grid-rows-2 gap-0.5 h-full w-full" data-id="element-219">
                      {[...Array(6)].map((_, idx) => <img key={idx} src={productImage} alt="StingFit" className="h-full w-full object-contain opacity-60" data-id="element-220" />)}
                    </div>
                  </div>}
              </div>

              <div className="flex justify-between items-start mb-2" data-id="element-221">
                <span className="font-bold text-gray-900 text-sm" data-id="element-222">
                  {b.qty} {b.qty === 1 ? 'Mes' : 'Meses'}
                </span>
                {b.best && <span className="text-[10px] font-bold bg-[#D4AF37] text-white px-2 py-0.5 rounded-full" data-id="element-223">
                    MEJOR
                  </span>}
              </div>
              <div className="flex items-baseline gap-2 mb-2" data-id="element-224">
                <span className="font-bold text-lg text-[#2D5016]" data-id="element-225">
                  {b.price}
                </span>
                <span className="text-xs text-gray-400 line-through" data-id="element-226">
                  {b.original}
                </span>
              </div>
              <div className="text-[10px] text-gray-500 mb-2" data-id="element-227">
                + E-book Gratis
              </div>
              <button className="w-full bg-gray-900 text-white text-xs font-bold py-2 rounded hover:bg-gray-800 transition-colors" data-id="element-228">
                Añadir
              </button>
            </div>)}
        </div>
      </div>
    </div>;
}